import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
	selector: 'app-top',
	templateUrl: './top.component.html',
	styleUrls: ['./top.component.css']
})
export class TopComponent implements OnInit {
	logininfo: Logininfo = this.auth.loginID;
	viewContents: any = {
		PersonalStatus: true,
		TeamStatus: true,
		AllStatus: true,
		EventCalendar: true,
		PersonalCalendar: true,
		AllCalendar: true,
		ReservationList: true,
		ProcessList: true,
		ClientList: true
	}
	isAdmin: boolean = false;
	acalref: boolean = false;
	ecalref: boolean = false;
	pcalref: boolean = false;

	status_count: number = 0;

	constructor(
		private route: ActivatedRoute,
		private location: Location,
		public auth: AuthService
	) { }

	ngOnInit() {
		this.getType();
	}

	getType(): void {
		this.viewContents = this.logininfo.auth;
		this.isAdmin = (this.logininfo.is_admin == 1);
		if (!this.isAdmin) {
			if (this.viewContents.PersonalStatus) {
				this.status_count++;
			}
			if (this.viewContents.TeamStatus) {
				this.status_count++;
			}
			if (this.viewContents.AllStatus) {
				this.status_count++;
			}
		}
	}
	calAllChange(val: boolean) {
		if (val) {
			this.pcalref = val;
			this.ecalref = val;
		} else {
			this.acalref = val;
		}
	}
	calEventChange(val: boolean) {
		if (val) {
			this.acalref = val;
			this.pcalref = val;
		} else {
			this.ecalref = val;
		}
	}
	calPerChange(val: boolean) {
		if (val) {
			this.acalref = val;
			this.ecalref = val;
		} else {
			this.pcalref = val;
		}
	}
}
